import React from 'react';

import {
  Panel,
  PanelHeader,
  PanelHeaderBack,
} from '@vkontakte/vkui';

import styles from './index.module.css';
import { DesktopAboutUsPanelProps } from './types';
import { useRouter } from '../../../../hooks/useRouter';
import { AboutUsPage } from '../../pages/AboutUsPage';

export const DesktopAboutUsPanel: React.FC<DesktopAboutUsPanelProps> = ({ id }) => {
  const router = useRouter();
  const  onBackClick = router.back;
  
  return (
    <Panel id={id} className={styles.panel}>
      <PanelHeader before={<PanelHeaderBack onClick={onBackClick}/>}>
        О проекте
      </PanelHeader>
      <AboutUsPage/>
    </Panel>);
};
